module.exports = __webpack_public_path__ + "img/logo-navbar.468e4f3c.svg";